import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { updateRecipe } from './recipes.service'
import { showToast } from '@/shared/utils/toast'
import type { RecipeFormData } from './types'

export function useUpdateRecipe(recipeId: string) {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { t } = useTranslation('recipes')

  return useMutation({
    mutationFn: (data: RecipeFormData) => updateRecipe(recipeId, data),
    onSuccess: () => {
      showToast(t('edit.success'))
      queryClient.invalidateQueries({ queryKey: ['recipes', 'list'] })
      queryClient.invalidateQueries({ queryKey: ['recipes', 'detail', recipeId] })
      navigate({ to: '/recipes/$recipeId', params: { recipeId } })
    },
  })
}
